import { render, staticRenderFns } from "./cool.vue?vue&type=template&id=282cbf37&scoped=true&"
import script from "./cool.vue?vue&type=script&lang=js&"
export * from "./cool.vue?vue&type=script&lang=js&"
import style0 from "./cool.vue?vue&type=style&index=0&id=282cbf37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282cbf37",
  null
  
)

component.options.__file = "cool.vue"
export default component.exports